import { MetaDefinition } from '@angular/platform-browser';

export function getMetaTags(isActiveMobileInterface: boolean): MetaDefinition[] {
  return [
    {
      name: 'viewport',
      content: isActiveMobileInterface ?
        'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0' :
        'width=device-width initial-scale=1, maximum-scale=2'
    },
    {
      name: 'theme-color',
      content: 'hsl(0, 0%, 100%)',
      media: '(prefers-color-scheme: light)'
    },
    {
      name: 'theme-color',
      content: 'hsl(0, 0%, 100%)',
      media: '(prefers-color-scheme: dark)'
    },
    {
      name: 'apple-mobile-web-app-status-bar-style',
      content: '#FFFFFF'
    },
    {
      name: 'apple-mobile-web-app-capable',
      content: 'yes'
    },
    {
      name: 'apple-mobile-web-app-title',
      content: 'RappiTravel'
    }
  ];
}
